<div>
  <dx-data-grid
    height="100%"
    width="100%"
    [columnResizingMode]="'widget'"
    [columnAutoWidth]="true"
    [dataSource]="dso"
    [twoWayBindingEnabled]="false"
    [stateStoring]="grid_stateStoring"
    [dateSerializationFormat]="null"
    (onInitialized)="grid_onInitialized($event)">
    <dxo-editing mode="none" [allowAdding]="false" [allowUpdating]="false" [allowDeleting]="false"></dxo-editing>

    <!--    <dxo-sorting mode="none"></dxo-sorting>-->

    <dxo-paging [pageSize]="config.get('itemsPerPage', 50)"></dxo-paging>

    <dxo-export [enabled]="true" fileName="MTM-Claims"></dxo-export>

    <!-- Columns -->

    <dxi-column caption="Broker" dataField="_broker" dataType="string" [allowSorting]="false"></dxi-column>

    <dxi-column
      caption="Date"
      dataField="_date"
      dataType="date"
      format="shortDate"
      [customizeText]="config.customizeShortDateText"
      [editorOptions]="{ type: 'date', displayFormat: 'shortDate' }"
      [allowSorting]="true"></dxi-column>

    <dxi-column caption="Trip Number" dataField="_tripId" dataType="string" [allowSorting]="false"></dxi-column>

    <dxi-column caption="STATUS" dataField="STATUS" dataType="string" [allowSorting]="true">
      <dxo-lookup [dataSource]="statusDso" displayExpr="_id" valueExpr="_id"></dxo-lookup>
    </dxi-column>

    <dxi-column
      caption="STATUS DATE"
      dataField="STATUSDATE"
      dataType="date"
      format="shortDate"
      [customizeText]="config.customizeShortDateText"
      [editorOptions]="{ type: 'date', displayFormat: 'shortDate' }"
      [allowSorting]="false"></dxi-column>

    <dxi-column caption="TRIP" dataField="TRIP" dataType="string" [allowSorting]="false"></dxi-column>

    <dxi-column
      caption="TRIP DATE"
      dataField="TRIPDATE"
      dataType="date"
      format="shortDate"
      [customizeText]="config.customizeShortDateText"
      [editorOptions]="{ type: 'date', displayFormat: 'shortDate' }"
      [allowSorting]="false"></dxi-column>

    <dxi-column caption="MEMBER NAME" dataField="MEMBERNAME" dataType="string" [allowSorting]="false"></dxi-column>

    <dxi-column
      caption="TRIP COST"
      dataField="TRIPCOST"
      dataType="number"
      *ngIf="isBiller$ | async"
      [allowSorting]="false">
      <dxo-format type="currency" [precision]="2"></dxo-format>
    </dxi-column>

    <dxi-column
      caption="CLAIM AMOUNT"
      dataField="CLAIMAMOUNT"
      dataType="number"
      *ngIf="isBiller$ | async"
      [allowSorting]="false">
      <dxo-format type="currency" [precision]="2"></dxo-format>
    </dxi-column>

    <dxi-column
      caption="PAYMENT"
      dataField="PAYMENT"
      dataType="number"
      *ngIf="isBiller$ | async"
      [allowSorting]="false">
      <dxo-format type="currency" [precision]="2"></dxo-format>
    </dxi-column>

    <dxi-column
      caption="APPEAL DEADLINE"
      dataField="APPEALDEADLINE"
      dataType="date"
      format="shortDate"
      [customizeText]="config.customizeShortDateText"
      [editorOptions]="{ type: 'date', displayFormat: 'shortDate' }"
      [allowSorting]="false"></dxi-column>

    <dxi-column
      caption="SCHEDULED PAY DATE"
      dataField="SCHEDULEDPAYDATE"
      dataType="date"
      format="shortDate"
      [customizeText]="config.customizeShortDateText"
      [editorOptions]="{ type: 'date', displayFormat: 'shortDate' }"
      [allowSorting]="false"></dxi-column>

    <dxi-column
      caption="DRIVER FIRSTNAME"
      dataField="DRIVERFIRSTNAME"
      dataType="string"
      [allowSorting]="false"></dxi-column>

    <dxi-column
      caption="DRIVER LASTNAME"
      dataField="DRIVERLASTNAME"
      dataType="string"
      [allowSorting]="false"></dxi-column>

    <dxi-column
      caption="LICENSE NUMBER"
      dataField="LICENSENUMBER"
      dataType="string"
      [allowSorting]="false"></dxi-column>

    <dxi-column caption="VEHICLE YEAR" dataField="VEHICLEYEAR" dataType="number" [allowSorting]="false"></dxi-column>

    <dxi-column caption="VEHICLE MAKE" dataField="VEHICLEMAKE" dataType="string" [allowSorting]="false"></dxi-column>

    <dxi-column caption="VEHICLE MODEL" dataField="VEHICLEMODEL" dataType="string" [allowSorting]="false"></dxi-column>

    <dxi-column caption="VEHICLE VIN" dataField="VEHICLEVIN" dataType="string" [allowSorting]="false"></dxi-column>

    <dxi-column
      caption="Denial Reason 1"
      dataField="DenialReason 1"
      dataType="string"
      [allowSorting]="false"></dxi-column>

    <dxi-column caption="MCI" dataField="trips._mci" dataType="string" [allowSorting]="false"></dxi-column>

    <dxi-column
      caption="Imported Date"
      dataField="_ctime"
      dataType="date"
      format="shortDateShortTime"
      [editorOptions]="{ type: 'date', displayFormat: 'shortDateShortTime' }"></dxi-column>

    <dxi-column
      caption="Updated Date"
      dataField="_rtime"
      dataType="date"
      format="shortDateShortTime"
      [editorOptions]="{ type: 'date', displayFormat: 'shortDateShortTime' }"></dxi-column>
    <!-- -->

    <!--    <dxi-column caption="Facility"-->
    <!--                dataType="string"-->
    <!--                cellTemplate="facilityCellTpl"-->
    <!--                [allowSearch]="false"-->
    <!--                [allowSorting]="false"-->
    <!--                [allowFiltering]="false"-->
    <!--                [allowHeaderFiltering]="false"-->
    <!--    ></dxi-column>-->

    <!--    <dxi-column caption="Assigned"-->
    <!--                dataType="boolean"-->
    <!--                cellTemplate="assignedCellTpl"-->
    <!--                [allowSearch]="false"-->
    <!--                [allowSorting]="false"-->
    <!--                [allowFiltering]="false"-->
    <!--                [allowHeaderFiltering]="false"-->
    <!--    ></dxi-column>-->

    <!-- Templates -->

    <ng-container *dxTemplate="let cellInfo of 'facilityCellTpl'">
      {{ cellInfo.data._facility }}
    </ng-container>

    <ng-container *dxTemplate="let cellInfo of 'assignedCellTpl'">
      <dx-check-box [value]="cellInfo.data._assigned" [readOnly]="true"></dx-check-box>
    </ng-container>
  </dx-data-grid>
</div>
